import { environment } from '../../../environments/environment';
declare global {
  interface String {
    toServerURL(isWebsite?: boolean): String;
  }
}
String.prototype.toServerURL = function (isWebsite?: boolean): string {
    return String(this);
}
export { }; 
